import { render, staticRenderFns } from "./BCXDottedCollapsible.vue?vue&type=template&id=07c1984a&scoped=true"
import script from "./BCXDottedCollapsible.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXDottedCollapsible.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXDottedCollapsible.vue?vue&type=style&index=0&id=07c1984a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c1984a",
  null
  
)

export default component.exports